import { Model } from 'dva'
import { Intent } from './types'
import { IntentsService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const Intents: Model = {
  namespace: 'intents',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let intents = yield select((state: any) => state.intents.list)
        if (!(intents.length > 0 && useCache)) {
          intents = yield call(IntentsService.intentsList, {})
          yield put({ type: 'modifyList', payload: intents })
        }
        onSuccess(intents)
      } catch (err: any) {
        FailureHandler('Error fetching intents', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let intent = yield select((state: any) =>
          state.intents.list.find((intent: Intent) => intent.id === id)
        )
        if (!intent) {
          intent = yield call(IntentsService.intentsRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: intent })
        onSuccess(intent)
      } catch (err) {
        FailureHandler('Could not find the intent!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(IntentsService.intentsCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a intent', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(IntentsService.intentsPartialUpdate, {
          id: id,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a intent', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(IntentsService.intentsDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a intent', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: Intent) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: Intent) => !action.payload.map((p: Intent) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: Intent) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetSLUIntents(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default Intents
